import * as Logger from '../../common/tools/logger';
import {
  BRAND_DOMAIN,
  OPT_IN_SERVICES,
  OPT_OUT_SERVICES
} from './config';

/**
 * Fires 1x1 pixel based on the `BRAND_DOMAIN` and `permission` value to the required systems
 * @param {boolean} permission Whether the user has given his / her consent / permission or not
 */
const requestService = (permission: boolean): void => {
  if (!OPT_IN_SERVICES.firstParty[BRAND_DOMAIN] || typeof OPT_IN_SERVICES.firstParty[BRAND_DOMAIN] === 'undefined') {
    Logger.error(`Compat`, `requestService`, `Could not determine first party opt-in / opt-out services for brand domain '${BRAND_DOMAIN}'.`);
    return;
  }

  if (permission) {
    new Image(1, 1).src = OPT_IN_SERVICES.thirdParty;
    new Image(1, 1).src = OPT_IN_SERVICES.firstParty[BRAND_DOMAIN];
  } else {
    new Image(1, 1).src = OPT_OUT_SERVICES.thirdParty;
    new Image(1, 1).src = OPT_OUT_SERVICES.firstParty[BRAND_DOMAIN];
  }
}

/**
 * Update the users NGUserID
 */
export const updateNgUserId = (): void => {
  if (typeof window.__tcfapi !== 'function') {
    Logger.error(`Compat`, `updateNgUserId`, `TCF API not initialized, not able to update the 'NGUserID'.`);
    return;
  }

  try {
    window.__tcfapi('getPermission', 2, (permission: boolean) => {
      requestService(permission);
    }, 'tgp');
  } catch (error) {
    Logger.error(`TCF`, `updateNgUserId`, `Failed to request the services to update 'NGUserID'.`, error);
  }
} 
